import backendHttpClient from './client/backendHttpClient';
import { HttpClient } from './client/httpClient';
import { SchemaModel } from '../models/schemaModel';
import { ErrorHandler } from './error/errorHandler';
import apiErrorHandler from './error/apiErrorHandler';
import { SchemaResponse } from './responses/schemaResponse';

class SchemaApi {
  constructor(private readonly httpClient: HttpClient,
              private readonly errorHandler: ErrorHandler) {}

  public fetchAll(): Promise<SchemaModel[]> {
    return this.httpClient.get<SchemaResponse[]>('/schemas')
      .then(response => response.map(it => this.mapToSchemaModel(it)))
      .catch(error => this.errorHandler.handleError(error, 'Failed to fetch all schemas'));
  }

  public fetchSchemaByName(schemaName: string): Promise<SchemaModel> {
    return this.httpClient.get<SchemaResponse>(`/schemas/${schemaName}`)
      .then(response => this.mapToSchemaModel(response))
      .catch(error => this.errorHandler.handleError(error, 'Failed to fetch schema by name'));
  }

  public createEmptySchema(schemaName: string): Promise<void> {
    return this.httpClient.post<void>('/schemas', { name: schemaName })
      .catch(error => this.errorHandler.handleError(error, 'Failed to create empty schema'));
  }

  public cloneSchema(sourceSchemaName: string, newSchemaName: string): Promise<void> {
    return this.httpClient.post<void>(`/schemas/${sourceSchemaName}/clone`, { name: newSchemaName })
      .catch(error => this.errorHandler.handleError(error, 'Failed to clone existing schema'));
  }

  public deleteSchema(schemaName: string): Promise<void> {
    return this.httpClient.delete<void>(`/schemas/${schemaName}`)
      .catch(error => this.errorHandler.handleError(error, 'Failed to delete schema by name'));
  }

  private mapToSchemaModel(response: SchemaResponse): SchemaModel {
    return {
      name: response.name,
      headCommitId: response.headCommitId,
    };
  }
}

export default new SchemaApi(backendHttpClient, apiErrorHandler);
